module.exports = __webpack_public_path__ + "static/img/home_logo_img1.703f5e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_logo_img1.png
// module id = iWYF
// module chunks = 3